import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { getTypedFormComponents } from 'Src/feature/form/getTypedFormComponents';
import { useForm } from 'Src/feature/form/useForm';
import { Modal } from 'Src/feature/modal/Modal';
import { ModalAction } from 'Src/feature/modal/ModalAction';
import { ModalActions } from 'Src/feature/modal/ModalActions';
import { ModalContent } from 'Src/feature/modal/ModalContent';
import { ModalHeader } from 'Src/feature/modal/ModalHeader';
import { ModalTitle } from 'Src/feature/modal/ModalTitle';

const sectionId = 'CheckItemVoidReasonModal';

interface CheckItemVoidReasonModalProps {
  open: boolean;
  form: ReturnType<typeof useForm<{ reasonId: number }>>;
  reasonOptions: { value: number, label: string }[];
  onClose: () => void;
  onVoid: () => void;
}

const { Form, Field } = getTypedFormComponents<{ reasonId: number }>();

const CheckItemVoidReasonModal: FC<CheckItemVoidReasonModalProps> = ({ open, form, reasonOptions, onClose, onVoid }) => {
  const { t } = useTranslation();

  return (
    <Modal
      data-testid={sectionId}
      open={open}
      onBackDropClick={onClose}
    >
      <ModalHeader>
        <ModalTitle copy={t('voidReason.labels.selectOne')} />
      </ModalHeader>

      <ModalContent>
        <Form usedForm={form}>
          <Field
            type="dropdownList"
            name="reasonId"
            label={t('voidReason.label')}
            options={reasonOptions}
            fullWidth
          />
        </Form>
      </ModalContent>

      <ModalActions>
        <ModalAction
          label={t('labels.cancel')}
          color="secondary"
          onClick={onClose}
        />
        <ModalAction
          label={t('labels.void')}
          color="primary"
          onClick={onVoid}
          disabled={!form.state.isValid}
        />
      </ModalActions>
    </Modal>
  );
};

export { CheckItemVoidReasonModal, sectionId };
